import instance from "../api/configuration/configure";

export const refreshToken = async (refreshToken: string | null) => {
    return await instance
        .post(
            process.env.REACT_APP_SERVER_URL + "api/auth/refresh-token",
            refreshToken == null ? '' : refreshToken);
};
